import en from './en';
import de from './de';
import it from './it';

export default { en, de, it };
